// React
import React from "react";
// Bootstrap
import { Well, Button } from "react-bootstrap";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./ErrorMessageBlock.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export class MaintenanceMessageBlock extends React.Component {
    render() {
        let { title, subTitle, buttonText, buttonCallback } = this.props;
        return (React.createElement("div", { className: styles.container },
            React.createElement(Well, { className: styles.errorMessages },
                React.createElement("h3", null, title),
                React.createElement("h4", null, "We are busy upgrading Insights with new features."),
                React.createElement("h4", null, "We apologise for the inconvenience and appreciate your patience."),
                React.createElement("h4", null, subTitle),
                React.createElement(Button, { bsStyle: "primary", onClick: () => buttonCallback() }, buttonText))));
    }
}
